import { useQuery } from '@tanstack/react-query';
import { reachoutClient } from 'clients/ReachoutClient/ReachoutClient';

import type { JobImprovedGetDetailOutput } from 'clients/ReachoutClient/ReachoutClient.types';

import { queryClient } from 'config/queryClient';
import { QueryKey } from 'types/query';

const getJobImprovedCacheKey = (id: number) => [QueryKey.useJobImprovedQuery, id];

export const useJobImprovedQuery = (id: string | number | null | undefined) => {
  return useQuery<JobImprovedGetDetailOutput>(
    [QueryKey.useJobImprovedQuery, id],
    async () => {
      if (!id) throw new Error('Id is required');

      const { data } = await reachoutClient.getJobImproved(Number(id));

      return data;
    },
    { enabled: !!id },
  );
};

useJobImprovedQuery.prefetchQuery = async (id: number) => {
  return queryClient.prefetchQuery([QueryKey.useJobImprovedQuery, id], () => reachoutClient.getJobImproved(id));
};

export { getJobImprovedCacheKey };
